import { render, staticRenderFns } from "./ResponseType5.vue?vue&type=template&id=22ff1562&scoped=true&"
import script from "./ResponseType5.vue?vue&type=script&lang=js&"
export * from "./ResponseType5.vue?vue&type=script&lang=js&"
import style0 from "./ResponseType5.vue?vue&type=style&index=0&id=22ff1562&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ff1562",
  null
  
)

export default component.exports